

import { Component, Vue } from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import InternalTicketsRepositoryInterface, { Ticket, TicketType } from '@/services/Internal-Tickets/interfaces';
import AddBug from '@/views/pages/internal-tickets/AddBug.vue';

@Component({
  components: { AddBug },
  inject: ['internalTicketsRepository'],
})
export default class Archive extends Vue {
  public loading: boolean = true;

  public tickets: Ticket[] = [];
  public count: number = 0;

  public readonly internalTicketsRepository: InternalTicketsRepositoryInterface;
  public readonly search = ''

  public headers: DataTableHeader[] = [
    { text: 'Title', value: 'title' },
    { text: 'Assignee', value: 'assignee.username' },
    { text: 'Reporter', value: 'reporter' },
    { text: 'Date&Time', value: 'createdAt' },
    { text: 'priority', value: 'priority.name', sortable: false },
    { text: 'status', value: 'status.name', sortable: false },
  ];

  public async mounted(): Promise<void> {
    await this.initialize();
    this.loading = false;
  }

  public async initialize(): Promise<void> {
    [this.tickets, this.count] = await this.getArchive();
  }

  public formatDate(timestamp: string) {
    const date = new Date(timestamp);
    return date.toLocaleString(); // returns a string in the format "4/4/2023, 3:04:36 PM" (based on the user's browser settings)
  }

  public async getArchive(): Promise<[Ticket[], number]> {
    try {
      return this.internalTicketsRepository.getArchive();
    } catch (e) {
      this.$errorDialog.show('Failed to retrieve archive: ' + e.message);
      return [[], 0];
    }
  }

}
